module.exports = __webpack_public_path__ + "static/media/telegram.b69ee55c.svg";